import { NarrativeFeedback } from '../../NarrativeFeedback';
import { NarrativeHeader } from '../../PublicNarrativeHeader';
import { NarrativeSidebar } from '../../NarrativeSidebar';
import { PublicNarrativeRichTextEditor } from '../../PublicNarrativeEditor';
import { Props } from '../types';

export const MobileLayout = ({
  errors,
  values,
  onChange,
  isLoading,
  onSubmit,
  submitLabel,
  author,
  initialContentHtml,
  company,
  onReset,
}: Props) => (
  <>
    <div className="grid gap-x2 content-start grid-rows-[min-content_min-content_auto]">
      <NarrativeHeader
        errors={errors}
        values={values}
        onChange={onChange}
        isLoading={isLoading}
        onSubmit={onSubmit}
        submitLabel={submitLabel}
        author={author}
      />
      <NarrativeFeedback />

      <NarrativeSidebar
        company={company}
        onChange={onChange}
        values={values}
        onReset={onReset}
        readOnly={false}
        authorDisplayName={author.displayName || author.name}
      />
    </div>
    <PublicNarrativeRichTextEditor
      onUpdate={(content) => onChange({ content })}
      defaultContent={initialContentHtml}
    />
  </>
);
